import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { AUTH_CONFIG } from '../../config/auth-config';
import { IAuthService } from '../../services/iauth.service';
import { ContainerManagerLoginComponent } from '../container-manager-login/container-manager-login.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    ToastModule,
    ProgressSpinnerModule,
    ButtonModule,
    InputTextModule,
    PasswordModule,
    ContainerManagerLoginComponent,
  ],
  providers: [MessageService],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  private authService = inject(IAuthService);
  private router = inject(Router);
  private fb = inject(FormBuilder);
  private config = inject(AUTH_CONFIG);
  private messageService = inject(MessageService);

  loadding = false;
  form = this.criarForm();

  get enableRegistration() {
    return this.config.features.enableRegistration;
  }

  get registrationRoute() {
    return this.config.routes?.registrationRoute || 'novo-cadastro';
  }

  get resetPasswordRoute() {
    return this.config.routes?.requestPasswordResetRoute || 'solicitar-reset-senha';
  }

  ngOnInit() {
    if (!this.authService.isAccessTokenInvalido()) {
      const redirectUrl = this.config.routes?.redirectAfterLogin || '/dashboard';
      this.router.navigate([redirectUrl]);
    }
  }

  login() {
    const { usuario, senha } = this.form.value;

    this.loadding = true;
    this.form.disable();
    this.authService
      .login(usuario!, senha!)
      .then(() => {
        const redirectUrl = this.config.routes?.redirectAfterLogin || '/dashboard';
        this.router.navigate([redirectUrl]);
        this.loadding = false;
        this.form.enable();
      })
      .catch((erro) => {
        this.loadding = false;
        this.form.enable();
        const errorMessage =
          erro.error?.userMessage ??
          erro?.message ??
          'Erro ao processar serviço remoto. Tente novamente.';
        this.messageService.add({
          severity: 'error',
          summary: 'Erro ao fazer login',
          detail: errorMessage,
        });
      });
  }

  private criarForm() {
    return this.fb.group({
      usuario: new FormControl<string>('', {
        validators: [Validators.required, Validators.email],
        nonNullable: true,
      }),
      senha: new FormControl<string>('', {
        validators: [Validators.required, Validators.min(5)],
        nonNullable: true,
      }),
    });
  }
}
